import { TFunction } from "i18next";

export interface UserType {
  userID: number;
  name: string;
  email: string;
  role: "Admin" | "Customer";
  subscription: "free" | "standard" | "premium" | "pro";
  theme: "light" | "dark";
  fontSize: "normal" | "large";
}

export interface TabType {
  tabID: number;
  sidebarItemID?: number;
  name: string;
  value?: string;
  position: number;
}

export interface SidebarMenuItemType {
  sidebarItemID: number;
  userID: string;
  name: string;
  position: number;
  warningText: string;
  adviseText: string;
}

export enum Unit {
  Degrees = "degrees",
  Day = "day",
  PerMinute = "perMinute",
  PerDay = "perDay",
  Percent = "percent",
  Hours = "hours",
  MgPerLiter = "mgPerLiter",
  Weight = "weight",
  SizeCM = "sizeCM",
  MMolPerLiter = "mMolPerLiter",
  Month = "month",
  KgPerM2 = "kgPerM2",
}

export const getUnitDisplayName = (t: TFunction) => {
  const UnitDisplayName = {
    [Unit.Degrees]: "°C",
    [Unit.Day]: t("dayUnit"),
    [Unit.PerMinute]: "/min",
    [Unit.PerDay]: `/${t("dayUnit")}`,
    [Unit.Percent]: "%",
    [Unit.Hours]: t("hoursUnit"),
    [Unit.MgPerLiter]: "mg/l",
    [Unit.Weight]: "kg",
    [Unit.SizeCM]: "cm",
    [Unit.MMolPerLiter]: "mmol/l",
    [Unit.Month]: t("monthUnit"),
    [Unit.KgPerM2]: "kg/m²",
  };
  return UnitDisplayName;
};

export enum FieldTypeType {
  Select = "select",
  Boolean = "boolean",
  BooleanText = "booleanText",
  ButtonGroup = "buttonGroup",
  Text = "text",
  Number = "number",
  Cascader = "cascader",
  MultipleChoice = "multipleChoice",
  NumberNumber = "numberNumber",
  Button = "button",
  StaticText = "staticText",
  ButtonText = "buttonText",
  Spacer = "spacer",
  Urine = "urine",
  BMICalculator = "bmiCalculator",
  TextArea = "textArea",
}

export const getFieldTypeDisplayName = (t: TFunction) => {
  const FieldTypeDisplayName = {
    [FieldTypeType.Select]: t("selectField"),
    [FieldTypeType.Boolean]: t("booleanField"),
    [FieldTypeType.BooleanText]: t("booleanField"),
    [FieldTypeType.ButtonGroup]: t("buttonGroupField"),
    [FieldTypeType.Text]: t("textInput"),
    [FieldTypeType.Number]: t("numberInput"),
    [FieldTypeType.Cascader]: t("cascaderField"),
    [FieldTypeType.MultipleChoice]: t("multiSelectField"),
    [FieldTypeType.NumberNumber]: t("numberNumberInput"),
    [FieldTypeType.Button]: t("buttonField"),
    [FieldTypeType.StaticText]: t("staticTextField"),
    [FieldTypeType.ButtonText]: t("buttonField"),
    [FieldTypeType.Spacer]: t("spacer"),
    [FieldTypeType.Urine]: t("urineField"),
    [FieldTypeType.BMICalculator]: t("bmiCalculator"),
    [FieldTypeType.TextArea]: t("textArea"),
  };
  return FieldTypeDisplayName;
};

export interface ReportFieldType {
  tab?: string;
  name?: string;
  value?: string;
  data: FieldType[];
}

export interface FieldType {
  fieldID: number | string;
  tabID: number;
  name: string;
  position: number;
  type: FieldTypeType;
  placeholder: string;
  unit?: Unit;
  defaultValue: string;
  noteOption: boolean;
  value: any;
  options?: OptionType[];
  visible?: boolean;
}

export interface APIFieldType {
  tabID: number;
  fieldID: string | number;
  name: string;
  position: number;
  type: FieldTypeType;
  unit?: Unit;
  defaultValue?: string;
  noteOption?: boolean;
  options?: OptionType[];
}

export interface OptionType {
  optionID: number;
  fieldID: number;
  name: string;
  value: string;
  position: number;
  subOptions?: SubOptionType[];
}

export interface SubOptionType {
  subOptionID: number;
  optionID: number;
  position: number;
  name: string;
  value: string;
}
